import { ref } from 'vue';

// One state shared by early service-worker events and the UI mounted afterwards.
export const availableUpdate = ref(null);
export const updateInProgress = ref(false);
let accepting = false;
let reloaded = false;

export function offerUpdate(detail = {}) {
  availableUpdate.value = { ...availableUpdate.value, ...detail };
  window.dispatchEvent?.(new CustomEvent('pwa:update-available', { detail }));
}

export function handleControllerChange() {
  // Another tab may activate a worker. Never discard this tab's unsaved work.
  if (accepting) reloadOnce();
  else offerUpdate({ controlled: true });
}

function reloadOnce() {
  if (reloaded) return;
  reloaded = true;
  window.location.reload();
}

export function applyAvailableUpdate() {
  if (accepting || navigator.onLine === false) return;
  accepting = true;
  updateInProgress.value = true;
  const waiting = availableUpdate.value?.registration?.waiting;
  if (waiting) {
    try {
      waiting.postMessage({ type: 'SKIP_WAITING' });
      // Some iOS versions don't dispatch controllerchange while returning from suspension.
      window.setTimeout(reloadOnce, 5000);
    } catch (error) { reloadOnce(); }
  } else reloadOnce();
}
